import React from 'react'
import './social-media.scss'

import facebook from '../../../assets/images/redes/facebook.svg'
import { graphql, useStaticQuery } from 'gatsby'
import { encryptUserInfo } from '../../../utils/encryptUserInfo'
import { pushDataLayerEvent } from '../../../utils/metricManagementUtil'

const SocialMedia = ({ className = "" }) => {
  const { allContentfulVConfidentTransversal } = useStaticQuery(
    graphql`
      query socialMedia {
        allContentfulVConfidentTransversal {
          nodes {
            node_locale
            pais
            tieneRedesSociales
            redesSociales {
              redireccionComponente
              imagenComponente {
                file {
                  url
                }
                description
              }
            }
          }
        }
      }
    `
  )

  const dataLayerSocialMedia = (option) => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Iconos_VConfident',
      category: 'v-confident',
      action: 'click',
      label: option,
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  const redesInfo = allContentfulVConfidentTransversal.nodes.filter(
    e => e.node_locale === 'es-CO' && process.env.LOCALE.includes(e.pais)
  )[0]

  return (
    <>
      {redesInfo.tieneRedesSociales ? (
        <div className={"f-social-media" + (className ? " "+className : "")}>
          {redesInfo.redesSociales.map((item, i) => {
            return (
              <a
                key={`red-${i + 1}`}
                className="f-social-media__image"
                href={item.redireccionComponente}
                rel="noreferrer"
                target="_blank"
                onClick={()=>dataLayerSocialMedia(item.redireccionComponente)}
              >
                <img
                  src={item.imagenComponente[0].file.url}
                  alt={item.imagenComponente[0].description}
                />
              </a>
            )
          })}
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export default SocialMedia
